module.exports = __webpack_public_path__ + "static/media/CC20-AP200-12.732e6a11.png";